import type { RouteRecordRaw } from 'vue-router'

import type { AccessLevel } from '@/types/auth.types'

/**
 * Agenda-ops routes (§24 lanci bloccati + §7 modifica titoli).
 * OWNER: fe-agenda (Phase 2).
 *
 * Registered ONCE in `router/index.ts` by fe-nav. fe-agenda adds new
 * agenda-ops routes here — never in index.ts or pms.routes.ts.
 * Catch-all stays library-owned in index.ts; never declare one here.
 */
const STAFF: AccessLevel[] = ['access_level.admin', 'access_level.manager']

export const agendaOpsRoutes: RouteRecordRaw[] = [
  {
    path: '/pms/blocked-launches',
    name: 'pms-blocked-launches',
    component: () => import('@/views/pms/agendaOps/BlockedLaunchesView.vue'),
    meta: { access_levels: STAFF },
  },
  {
    path: '/pms/blocked-formats',
    name: 'pms-blocked-formats',
    component: () => import('@/views/pms/agendaOps/BlockedFormatsView.vue'),
    meta: { access_levels: STAFF },
  },
  {
    path: '/pms/title-changes',
    name: 'pms-title-changes',
    component: () => import('@/views/pms/agendaOps/TitleChangesView.vue'),
    meta: { access_levels: STAFF },
  },
]
